module.exports = __webpack_public_path__ + "img/cassette-betamax.60c723ca.svg";